import { connect } from "react-redux";
import { ThunkDispatch } from "redux-thunk";

import { ApplicationState } from "../../../store/ApplicationState";
import { getGeneralInfo } from "../../../actions/AuthorizationDetailsTab";
import GeneralInfo from "../components/GeneralInfo";
import { GeneralInfoDispatchTypes } from "../../../models/DispatchTypes/AuthorizationDetailstab";

const mapStateToProps = ({
  generalInfoState
}: ApplicationState) => ({
    generalInfoState: generalInfoState.response,
});

const mapDispatchToProps = (
    dispatch: ThunkDispatch<ApplicationState, Record<string, never>, GeneralInfoDispatchTypes>
) => {
    return {
      getGeneralInfo: (referralId: number) => {
        dispatch(getGeneralInfo(referralId));
      },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(GeneralInfo);
